import { render, staticRenderFns } from "./birth-company-product.vue?vue&type=template&id=bf4452ce&scoped=true&"
import script from "./birth-company-product.vue?vue&type=script&lang=js&"
export * from "./birth-company-product.vue?vue&type=script&lang=js&"
import style0 from "./birth-company-product.vue?vue&type=style&index=0&id=bf4452ce&prod&lang=scss&"
import style1 from "./birth-company-product.vue?vue&type=style&index=1&id=bf4452ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4452ce",
  null
  
)

export default component.exports